var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1604_22222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3828 40C31.4285 40 40.3828 31.0457 40.3828 20C40.3828 8.9543 31.4285 0 20.3828 0C9.33712 0 0.382812 8.9543 0.382812 20C0.382812 31.0457 9.33712 40 20.3828 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.382812 20.0006C0.382812 28.5999 5.81031 35.9307 13.4263 38.7567V1.24463C5.81031 4.07041 0.382812 11.4013 0.382812 20.0006Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3833 20.0006C40.3833 11.4013 34.9559 4.07041 27.3398 1.24463V38.7567C34.9559 35.9307 40.3833 28.5999 40.3833 20.0006Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1604_22222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.382812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNg);
export default __webpack_public_path__ + "static/media/NG.09b36b3202acbf679461c326b8f0c723.svg";
export { ForwardRef as ReactComponent };